/* =====================================================================
   TABLIER SILIKOMART OFFERT — ajout automatique au panier
   Perle Dorée, opération du 1er septembre au 31 octobre 2026

   CE QUE FAIT CE SCRIPT
   Il surveille le panier, additionne UNIQUEMENT les lignes appartenant à
   la collection Silikomart, et ajoute ou retire le tablier tout seul dès
   que le seuil de 50 € est franchi dans un sens ou dans l'autre.

   CE QU'IL NE FAIT PAS, ET C'EST VOULU
   Il ne met aucun prix à zéro. C'est la remise automatique Shopify
   « Achetez X, obtenez Y » qui le fait, côté serveur, avec le même
   périmètre (50 € minimum dans la collection Silikomart). Si ce script
   tombe, la remise reste juste : personne n'est facturé par erreur, et
   un client qui ajoute le tablier à la main l'obtient quand même à 0 €.

   À RENSEIGNER AVANT MISE EN LIGNE : TABLIER_VARIANT_ID
   ===================================================================== */
(function () {
  'use strict';

  /* Périmètre : la collection publique Silikomart, qui est aussi celui de
     la remise Shopify. Ses règles excluent déjà le tablier, « le titre ne
     contient pas CADEAU », sinon il compterait dans le seuil qu'il
     récompense.

     ⚠️ Si quelqu'un modifie un jour les règles de cette collection, il
     modifie du même coup le périmètre de l'offre. Les deux doivent rester
     identiques à la remise « Tablier Silikomart offert ». */
  var COLLECTION = 'silikomart';
  var SEUIL_CENTIMES = 5000;                    // 50,00 € TTC
  var TABLIER_VARIANT_ID = 58585356534134;      // CADEAU – Tablier Silikomart exclusif
  var MARQUEUR = '_offre_tablier';   // propriété qui identifie la ligne ajoutée par nous
  var CLE_REFUS = 'pd_tablier_refuse';

  if (!TABLIER_VARIANT_ID) return;   // sécurité : rien tant que le tablier n'existe pas

  var eligibles = null;              // Set des product_id de la collection
  var enCours = false;               // évite les exécutions concurrentes
  var dernierPanier = null;          // dernier panier connu, avant la requête en cours
  var retraitAutomatique = false;    // vrai pendant NOTRE propre retrait du tablier

  function json(url, options) {
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error(url + ' -> ' + r.status);
      return r.json();
    });
  }

  /* Liste des produits éligibles, mise en cache le temps de la visite. */
  function chargerEligibles() {
    if (eligibles) return Promise.resolve(eligibles);
    var cache = null;
    try { cache = sessionStorage.getItem('pd_eligibles_' + COLLECTION); } catch (e) {}
    if (cache) {
      var liste = JSON.parse(cache);
      if (liste.length) {                 // un cache vide est un cache invalide
        eligibles = new Set(liste);
        return Promise.resolve(eligibles);
      }
      try { sessionStorage.removeItem('pd_eligibles_' + COLLECTION); } catch (e) {}
    }
    var ids = [];
    function page(n) {
      return json('/collections/' + COLLECTION + '/products.json?limit=250&page=' + n)
        .then(function (d) {
          var lot = (d && d.products) || [];
          lot.forEach(function (p) { ids.push(p.id); });
          if (lot.length === 250 && n < 8) return page(n + 1);
        });
    }
    return page(1).then(function () {
      /* Ne JAMAIS mettre en cache une liste vide : une réponse ratée
         (limite de débit, collection non publiée) resterait alors en
         mémoire pour toute la visite et le script ne ferait plus rien. */
      if (!ids.length) throw new Error('liste eligible vide, on ne met pas en cache');
      eligibles = new Set(ids);
      try { sessionStorage.setItem('pd_eligibles_' + COLLECTION, JSON.stringify(ids)); } catch (e) {}
      return eligibles;
    });
  }

  /* Somme des lignes du panier appartenant à la collection.
     On utilise final_line_price : c'est le montant après remises de ligne,
     donc la même base que celle sur laquelle Shopify évalue la remise. */
  function sousTotalEligible(panier) {
    return (panier.items || []).reduce(function (somme, ligne) {
      if (ligne.variant_id === TABLIER_VARIANT_ID) return somme;
      return eligibles.has(ligne.product_id) ? somme + ligne.final_line_price : somme;
    }, 0);
  }

  function ligneTablier(panier) {
    var trouve = null;
    (panier.items || []).forEach(function (l) {
      if (l.variant_id === TABLIER_VARIANT_ID) trouve = l;
    });
    return trouve;
  }

  function ajouter() {
    var props = {};
    props[MARQUEUR] = 'oui';
    return json('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: TABLIER_VARIANT_ID, quantity: 1, properties: props }] })
    });
  }

  /* Retrait décidé par le script parce que le panier est repassé sous le
     seuil. Le drapeau évite que la surveillance ci-dessous le prenne pour
     un refus du client : sans lui, le script se saborde tout seul et le
     tablier ne revient plus de la visite, même une fois les 50 € repassés. */
  function retirer(ligne) {
    retraitAutomatique = true;
    var promesse = json('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: ligne.key, quantity: 0 })
    });
    retraitAutomatique = false;   // l'interception est synchrone, elle a déjà eu lieu
    return promesse;
  }

  function rafraichirAffichage() {
    // Prévient le thème et les apps que le panier a bougé.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function verifier() {
    if (enCours) return;
    enCours = true;
    chargerEligibles()
      .then(function () { return json('/cart.js'); })
      .then(function (panier) {
        dernierPanier = panier;      // sert de reference au prochain retrait manuel
        var total = sousTotalEligible(panier);
        var present = ligneTablier(panier);
        var eligible = total >= SEUIL_CENTIMES;

        // Le client a retiré le tablier lui-même alors qu'il y avait droit :
        // on respecte son choix pour le reste de la visite.
        var refuse = false;
        try { refuse = sessionStorage.getItem(CLE_REFUS) === '1'; } catch (e) {}

        if (eligible && !present && !refuse) {
          return ajouter().then(rafraichirAffichage);
        }
        if (!eligible && present) {
          try { sessionStorage.removeItem(CLE_REFUS); } catch (e) {}
          return retirer(present).then(rafraichirAffichage);
        }
      })
      .catch(function (e) {
        // Silencieux côté client : la remise Shopify reste la règle qui fait foi.
        if (window.console && console.debug) console.debug('[tablier]', e);
      })
      .then(function () { enCours = false; });
  }

  /* Détecte le retrait manuel du tablier pour ne pas le réimposer en boucle.

     ⚠️ Ce contrôle DOIT se faire sur l'état du panier connu AVANT la
     requête. Interroger /cart.js à cet instant renvoie encore l'ancien
     panier : la suppression n'est pas enregistrée, on croit donc que le
     tablier est toujours là et on le remet aussitôt. C'est la boucle
     qu'on veut éviter. */
  function surveillerRetraitManuel(url, corps) {
    if (retraitAutomatique) return;   // c'est nous, pas le client
    if (!/\/cart\/(change|update)/.test(url) || !dernierPanier) return;
    try {
      var d = typeof corps === 'string' ? JSON.parse(corps) : corps;
      if (!d || Number(d.quantity) !== 0) return;

      var lignes = dernierPanier.items || [];
      var visee = null;
      if (d.id !== undefined) {
        for (var i = 0; i < lignes.length; i++) {
          // /cart/change.js accepte la cle de ligne ou l'identifiant de variante
          if (lignes[i].key === d.id || String(lignes[i].variant_id) === String(d.id)) {
            visee = lignes[i]; break;
          }
        }
      } else if (d.line !== undefined) {
        visee = lignes[Number(d.line) - 1] || null;
      }

      if (visee && visee.variant_id === TABLIER_VARIANT_ID) {
        try { sessionStorage.setItem(CLE_REFUS, '1'); } catch (e) {}
      }
    } catch (e) {}
  }

  /* Le panier peut être modifié par le thème ou par une app : on écoute
     les appels réseau plutôt que de sonder en boucle. */
  var fetchOrigine = window.fetch;
  window.fetch = function (entree, options) {
    var url = (typeof entree === 'string') ? entree : (entree && entree.url) || '';
    var reponse = fetchOrigine.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      surveillerRetraitManuel(url, options && options.body);
      reponse.then(function () { setTimeout(verifier, 120); }).catch(function () {});
    }
    return reponse;
  };

  var envoiOrigine = XMLHttpRequest.prototype.send;
  var ouvertureOrigine = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    this.__pdUrl = url;
    return ouvertureOrigine.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (corps) {
    var xhr = this;
    if (/\/cart\/(add|change|update|clear)/.test(xhr.__pdUrl || '')) {
      surveillerRetraitManuel(xhr.__pdUrl, corps);
      xhr.addEventListener('load', function () { setTimeout(verifier, 120); });
    }
    return envoiOrigine.apply(this, arguments);
  };

  /* ===================================================================
     MASQUAGE DU TABLIER DANS LA RECHERCHE DU SITE

     Le produit doit rester publié sur la boutique en ligne pour que
     Shopify accepte de l'ajouter au panier. Il reste donc trouvable par
     la recherche, alors qu'il n'a rien à y faire : c'est un cadeau, pas
     un article à vendre à l'unité.

     Deux surfaces à traiter :
     - le menu déroulant de suggestions, alimenté par /search/suggest.json
       que Shopify sert directement, donc filtré à la réponse ;
     - la page de résultats, filtrée dans le DOM.
     =================================================================== */

  var HANDLE_TABLIER = 'cadeau-tablier-silikomart-exclusif';

  /* 1. Filtre la réponse JSON des suggestions avant que le thème la lise. */
  var fetchAvantRecherche = window.fetch;
  window.fetch = function (entree, options) {
    var url = (typeof entree === 'string') ? entree : (entree && entree.url) || '';
    var reponse = fetchAvantRecherche.apply(this, arguments);
    if (!/\/search\/suggest/.test(url)) return reponse;

    return reponse.then(function (r) {
      return r.clone().json().then(function (d) {
        try {
          var p = d && d.resources && d.resources.results && d.resources.results.products;
          if (p) {
            d.resources.results.products = p.filter(function (x) {
              return x.handle !== HANDLE_TABLIER;
            });
          }
        } catch (e) {}
        return new Response(JSON.stringify(d), {
          status: r.status, statusText: r.statusText, headers: r.headers
        });
      }).catch(function () { return r; });
    });
  };

  /* 2. Retire la carte produit des résultats déjà affichés. */
  function masquerDansLeDom(racine) {
    var liens = (racine || document).querySelectorAll(
      'a[href*="' + HANDLE_TABLIER + '"]');
    for (var i = 0; i < liens.length; i++) {
      var carte = liens[i].closest(
        'li, .card, .product-card, .grid__item, [class*="product-item"], [class*="predictive"]');
      if (carte && !carte.dataset.pdMasque) {
        carte.dataset.pdMasque = '1';
        carte.style.display = 'none';
      }
    }
  }

  masquerDansLeDom();
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { masquerDansLeDom(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verifier);
  } else {
    verifier();
  }
})();
